export default {
  SUPPLIERS_LIST: "Liste des fournisseurs",
  ADD_SUPPLIER: "Ajouter un fournisseur",
  SUPPLIER_ADDED: "Fournisseur ajouté",
  EDIT_SUPPLIER: "Modifier un fournisseur",
  SUPPLIER_UPDATED: "Fournisseur mis à jour",
  DELETE_THIS_SUPPLIER: "Supprimer ce fournisseur ?",
  SUPPLIER_DELETED: "Fournisseur supprimé",
  BILLING_INFORMATIONS_SAME_AS_SUPPLIER: "Même adresse que le fournisseur",
  ADD_PRODUCT: "Ajouter un produit",
  ADD_SUPPLIER_FILE: "Ajouter un fichier produits",
  ADD_SUPPLIER_FILE_RESULTS: "Résultats de la synchronisation du fichier",
  RUN_SUPPLIER_FILE_SYNC: "Lancer l'import",
  SYNC_PREVIEW: "Aperçu de la synchronisation",
  PRODUCTS_CREATED: "Créés",
  PRODUCTS_UPDATED: "Mis à jour",
  PRODUCTS_DELETED: "Supprimés",
  PRODUCTS_ERRORS: "Erreurs",
  PRODUCTS_WARNINGS: "Avertissements",
  PRODUCTS_UNTOUCHED: "Produits intacts",
  PRODUCT: "Produit",
  ERROR: "Erreur",
  WARNING: "Avertissement",
  RUN_SYNCHRONISATION: "Lancer la synchronisation",
  SYNC_RESULTS: "Résultats de la synchronisation",
  LAST_SYNC_PRODUCTS: "Produits synchronisés",
  SHOW_FILE: "Voir le fichier",
  ADD_TO_WAREHOUSE_MODELS: "Ajouter aux modèles",
  DELETE_FROM_WAREHOUSE_MODELS: "Supprimer des modèles",
  ADD_TO_WAREHOUSES: "Ajouter aux entrepôts",
  DELETE_FROM_WAREHOUSES: "Supprimer des entrepôts",
  PRODUCTS_ADDED: "Ajoutés",
  PRODUCTS_PROCESSED: "Produits traités",
  ACTIVE: "Actif",
  INACTIVE: "Inactif",
  ACTIVATE: "Activer",
  DEACTIVATE: "Désactiver",
  SUPPLIER_ACTIVATED: "Fournisseur Activé",
  SUPPLIER_DEACTIVATED: "Fournisseur Désactivé",
  PURCHASE_TAX_SETTINGS: "Paramètres de taxes sur les frais d'achat",
  PURCHASE_TAX_SETTINGS_HELP: "Cochez les frais sur lesquels ce fournisseur facture la TPS et la TVQ. Appliqué aux frais ajoutés lors de la génération d'une facture d'achat.",
  REFRESH_PRICES: "Rafraichir les prix",
  REFRESH_PRICES_CONFIRM_TITLE: "Rafraichir les prix des entrepots?",
  REFRESH_PRICES_CONFIRM_MESSAGE: "Tous les prix des produits en entrepot seront mis a jour a partir des prix des produits.<br><br><strong>Les produits avec un prix personnalise ne seront PAS mis a jour.</strong>",
  REFRESH_PRICES_RESULTS: "Resultats du rafraichissement des prix",
  PRICES_UPDATED: "Prix mis a jour",
  BUYING_PRICES_UPDATED: "Prix d'achat mis a jour",
  SELLING_PRICES_UPDATED: "Prix de vente mis a jour",
};
